import api from "./api";

export const listeningResultsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listeningAiFeedBackResults: builder.mutation({
      query: ({ payload, page }) => ({
        url: `/api/listening/listeningstudentsdata?page=${page}&limit=${10}`,
        method: "POST",
        body: payload,
      }),
    }),
    fetchListeningTestChart: builder.query({
      query: (id) => ({
        url: `/api/listening/listeningtestchart?studentId=${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useListeningAiFeedBackResultsMutation,
  useFetchListeningTestChartQuery,
} = listeningResultsApi;
